import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PartnerPlanNoteDisplayForm from 'views/PartnerPlans/PartnerPlanNoteDisplayForm'
import constants from 'constants'

class PartnerPlanNoteForm extends Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    forms: PropTypes.object.isRequired,
    hide: PropTypes.func.isRequired,
    id: PropTypes.string,
    modals: PropTypes.object.isRequired,
    noteHeader: PropTypes.string,
    partnerPlan: PropTypes.object.isRequired,
    partnerPlanForm: PropTypes.object.isRequired,
    selectedPartner: PropTypes.instanceOf(Array).isRequired,
    selectedPlan: PropTypes.object.isRequired,
  }

  static defaultProps = {
    id: `${constants.PARTNERPLAN.FORMS.NOTES}`,
    noteHeader: '',
  }

  render() {
    const {
      modals, hide, forms, id, partnerPlan, partnerPlanForm, selectedPartner, selectedPlan, currentUser, noteHeader,
    } = this.props

    return (
      <PartnerPlanNoteDisplayForm
        currentUser={currentUser}
        description="Previous notes"
        dispatch={this.props.dispatch}
        forms={forms}
        hide={hide}
        id={id}
        modals={modals}
        noteHeader={noteHeader}
        partnerPlan={partnerPlan}
        partnerPlanForm={partnerPlanForm}
        selectedPartner={selectedPartner}
        selectedPlan={selectedPlan}
        title={noteHeader}
      />
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  modals: state.modals,
  forms: state.forms,
  partnerPlan: state.partnerPlan,
  partnerPlanForm: state.partnerPlanForm,
  selectedPartner: (Object.keys(state.personalinfos.selectedPartner).length === 0 && sessionStorage.getItem('SelectedPartner') !== null ?
    JSON.parse(sessionStorage.getItem('SelectedPartner')) :
    state.personalinfos.selectedPartner),
  selectedPlan: (Object.keys(state.partnerPlans.selectedPlan).length === 0 && sessionStorage.getItem('SelectedPlan') !== null ?
    JSON.parse(sessionStorage.getItem('SelectedPlan')) :
    state.partnerPlans.selectedPlan),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PartnerPlanNoteForm))



// WEBPACK FOOTER //
// ./src/containers/PartnerPlanNoteForm.js